module.exports = __webpack_public_path__ + "theme/assets/img/d29f7a4e4d69d85c3d30c0628286ba10.png";